import { bangkachaoContent } from './bangkachao';
import { bangkokContent } from './bangkok';
import { benchakittiParkContent } from './benchakitti-park';
import { chiangMaiContent } from './chiang-mai';
import { chiangRaiContent } from './chiang-rai';
import { doiInthanonContent } from './doi-inthanon';
import { emeraldCaveContent } from './emerald-cave';
import { huaHinContent } from './hua-hin';
import { kanchanaburiContent } from './kanchanaburi';
import { khaoLakContent } from './khao-lak';
import { khaoSokContent } from './khao-sok';
import { khlongMaeKhaContent } from './khlong-mae-kha';
import { kohKretContent } from './koh-kret';
import { koLantaContent } from './ko-lanta';
import { kohLipeContent } from './koh-lipe';
import { koSurinNueaContent } from './ko-surin-nuea';
import { kohChangContent } from './koh-chang';
import { kohKoodContent } from './koh-kood';
import { kohLarnContent } from './koh-larn';
import { kohPhanganContent } from './koh-phangan';
import { kohPhiPhiContent } from './koh-phi-phi';
import { kohSamuiContent } from './koh-samui';
import { kohTaoContent } from './koh-tao';
import { krabiContent } from './krabi';
import { lumphiniParkContent } from './lumphini-park';
import { paiContent } from './pai';
import { pattayaContent } from './pattaya';
import { phuketContent } from './phuket';
import { similanIslandsContent } from './similan-islands';
import { watSaketContent } from './wat-saket';
import { relatedArticlesSlugsMap } from './relatedArticlesSlugsMap';
import { Content } from '../../types';

// Define o tipo com todas as chaves possíveis do thailandDestinationsContentMap
export type ThailandDestinationKey =
  | 'bangkok'
  | 'chiang-mai'
  | 'phuket'
  | 'krabi'
  | 'koh-samui'
  | 'pai'
  | 'koh-phangan'
  | 'chiang-rai'
  | 'kanchanaburi'
  | 'koh-phi-phi'
  | 'koh-tao'
  | 'koh-lipe'
  | 'ko-lanta'
  | 'khao-sok'
  | 'similan-islands'
  | 'ko-surin-nuea'
  | 'khao-lak'
  | 'koh-kood'
  | 'koh-chang'
  | 'hua-hin'
  | 'pattaya'
  | 'doi-inthanon'
  | 'wat-saket'
  | 'koh-larn'
  | 'khlong-mae-kha'
  | 'ko-kret'
  | 'bangkachao'
  | 'lumphini-park'
  | 'benchakitti-park'
  | 'emerald-cave';

// Utilizamos Record para definir explicitamente o tipo do mapa
export const thailandDestinationsContentMap: Record<
  ThailandDestinationKey,
  Content
> = {
  bangkok: bangkokContent,
  'chiang-mai': chiangMaiContent,
  phuket: phuketContent,
  krabi: krabiContent,
  'koh-samui': kohSamuiContent,
  pai: paiContent,
  'koh-phangan': kohPhanganContent,
  'chiang-rai': chiangRaiContent,
  kanchanaburi: kanchanaburiContent,
  'koh-phi-phi': kohPhiPhiContent,
  'koh-tao': kohTaoContent,
  'koh-lipe': kohLipeContent,
  'ko-lanta': koLantaContent,
  'khao-sok': khaoSokContent,
  'similan-islands': similanIslandsContent,
  'ko-surin-nuea': koSurinNueaContent,
  'khao-lak': khaoLakContent,
  'koh-kood': kohKoodContent,
  'koh-chang': kohChangContent,
  'hua-hin': huaHinContent,
  pattaya: pattayaContent,
  'doi-inthanon': doiInthanonContent,
  'wat-saket': watSaketContent,
  'koh-larn': kohLarnContent,
  'khlong-mae-kha': khlongMaeKhaContent,
  'ko-kret': kohKretContent,
  bangkachao: bangkachaoContent,
  'lumphini-park': lumphiniParkContent,
  'benchakitti-park': benchakittiParkContent,
  'emerald-cave': emeraldCaveContent,
};

export const thailandDestinationsCardData = [
  {
    title: 'בנגקוק',
    description:
      'עיר הבירה של תאילנד - שילוב מסחרר של מקדשים עתיקים, גורדי שחקים, שווקים צבעוניים וחיים תוססים מסביב לשעון',
    imageUrl: '/images/thailand/bangkok/bangkok-preview.jpg',
    slug: 'bangkok',
    date: '15.11.2024',
    readTime: '4',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1027043&k_site=https%3A%2F%2Fwww.klook.com%2Fcity%2F4-bangkok-things-to-do%2F%3Fspm%3DSearchResult.SearchSuggest_LIST%26clickId%3D76562f76e0',
    getYourGuideUrl:
      'https://www.getyourguide.com/bngqvq-l169/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: "צ'אנג מאי",
    description:
      'עיר קסומה בצפון תאילנד - שילוב של מקדשים עתיקים, שווקים תוססים, טבע עוצר נשימה ותרבות מקומית חיה',
    imageUrl: '/images/thailand/chiang-mai/chiang-mai-preview.jpeg',
    slug: 'chiang-mai',
    date: '16.12.2024',
    readTime: '3.5',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1027236&k_site=https%3A%2F%2Fwww.klook.com%2Fcity%2F5-chiang-mai-things-to-do%2F%3Fspm%3DSearchResult.SearchSuggest_LIST%26clickId%3De11198e845',
    getYourGuideUrl:
      'https://www.getyourguide.com/ts-ng-my-l271/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: 'פוקט',
    description:
      'האי הגדול והפופולרי בתאילנד - חופים מהממים, חיי לילה סוערים, טבע מרהיב ואינספור אטרקציות לכל סוג של מטייל',
    imageUrl: '/images/thailand/phuket/phuket-preview.jpeg',
    slug: 'phuket',
    date: '28.11.2024',
    readTime: '4',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1027043&k_site=https%3A%2F%2Fwww.klook.com%2Fcity%2F7-phuket-things-to-do%2F%3Fspm%3DHome.SearchSuggest_LIST%26clickId%3D6fca4b0e36',
    getYourGuideUrl:
      'https://www.getyourguide.com/pvqt-l32123/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: 'קראבי',
    description:
      'חופים טרופיים, צוקים דרמטיים, איים קסומים וטבע עוצר נשימה - קראבי הוא חלום טרופי שמתגשם בדרום תאילנד',
    imageUrl: '/images/thailand/krabi/krabi-preview.jpeg',
    slug: 'krabi',
    date: '20.12.2024',
    readTime: '3',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1029376&k_site=https%3A%2F%2Fwww.klook.com%2Fcity%2F63-krabi-things-to-do%2F%3Fspm%3DCity.SearchSuggest_LIST%26clickId%3D031d59a087',
    getYourGuideUrl:
      'https://www.getyourguide.com/qrby-l2174/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: 'קו סמוי',
    description:
      'אי קסום במפרץ תאילנד - חופים לבנים, טיולים, איים סמוכים, אטרקציות לכל גיל וחיי לילה תוססים',
    imageUrl: '/images/thailand/koh-samui/koh-samui-preview.jpeg',
    slug: 'koh-samui',
    date: '07.11.2024',
    readTime: '3.5',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1029378&k_site=https%3A%2F%2Fwww.klook.com%2Fsearch%2Fresult%2F%3Fquery%3Dkoh%2520samui%2520activities%26needQueryIdentification%3Dtrue',
    getYourGuideUrl:
      'https://www.getyourguide.com/qv-smvy-l898/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: 'פאי',
    description:
      'עיירה קסומה בצפון תאילנד עם נוף הררי, שווקים ססגוניים, מעיינות חמים ואווירה רגועה במיוחד',
    imageUrl: '/images/thailand/pai/pai-preview.jpeg',
    slug: 'pai',
    date: '03.12.2024',
    readTime: '3',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1029379&k_site=https%3A%2F%2Fwww.klook.com%2Fsearch%2Fresult%2F%3Fquery%3DPai%2520Thailand%26spm%3DPOI_Destination.SearchStart_SearchHistory_LIST%26clickId%3De3663667bf',
    getYourGuideUrl:
      'https://www.getyourguide.com/py-l97258/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: 'קופנגן',
    description:
      'אי טרופי עם חופים קסומים, מסיבות פולמון סוערות, יוגה, טבע פראי ושנורקלינג באווירה שאין כמותה',
    imageUrl: '/images/thailand/koh-phangan/koh-phangan-preview.jpg',
    slug: 'koh-phangan',
    date: '05.01.2025',
    readTime: '3',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1029380&k_site=https%3A%2F%2Fwww.klook.com%2Fsearch%2Fresult%2F%3Fquery%3Dkoh%2520phangan%26spm%3DHome.TopNavigation.SearchInput%26clickId%3D084bedeb88',
    getYourGuideUrl:
      'https://www.getyourguide.com/qvpngn-l5038/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: "צ'אנג ראי",
    description:
      'עיר של מקדשים מרהיבים, טבע עוצמתי ואווירה שקטה בצפון תאילנד - נקודת יציאה למשולש הגבולות',
    imageUrl: '/images/thailand/chiang-rai/chiang-rai-preview.jpeg',
    slug: 'chiang-rai',
    date: '19.02.2025',
    readTime: '3',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1029382&k_site=https%3A%2F%2Fwww.klook.com%2Fcity%2F216-chiang-rai-things-to-do%2F%3Fspm%3DSearchResult.SearchSuggest_LIST%26clickId%3D3ecfe1eca7',
    getYourGuideUrl:
      'https://www.getyourguide.com/ts-ng-ry-l913/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: "קנצ'נאבורי",
    description:
      "היסטוריה מרתקת, מפלים קסומים, טבע ירוק ואווירה של שלווה - קנצ'נבורי היא תאילנד אחרת",
    imageUrl: '/images/thailand/kanchanaburi/kanchanaburi-preview.jpeg',
    slug: 'kanchanaburi',
    date: '18.01.2025',
    readTime: '3',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1029383&k_site=https%3A%2F%2Fwww.klook.com%2Fcity%2F254-kanchanaburi-things-to-do%2F%3Fspm%3DCity.SearchSuggest_LIST%26clickId%3Dd6d6984e64',
    getYourGuideUrl:
      'https://www.getyourguide.com/qnts-nbvry-l32274/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: 'קו פי פי',
    description:
      'איים עוצרי נשימה עם מים טורקיז, צוקים דרמטיים, חופים מדהימים ואווירה בלתי נשכחת - גן עדן בלב אנדמן',
    imageUrl: '/images/thailand/koh-phi-phi/koh-phi-phi-preview.jpeg',
    slug: 'koh-phi-phi',
    date: '14.11.2024',
    readTime: '3',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1029384&k_site=https%3A%2F%2Fwww.klook.com%2Fdestination%2Fp50293831-phi-phi-islands%2F',
    getYourGuideUrl:
      'https://www.getyourguide.com/yy-py-py-l9477/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: 'קו טאו',
    description:
      'מחפשים יעד שליו עם מים צלולים, צלילה מדהימה ושקיעות מרהיבות? קו טאו, אי הצבים של תאילנד, מציע שילוב מושלם בין רוגע להרפתקה',
    imageUrl: '/images/thailand/koh-tao/koh-tao-preview.jpeg',
    slug: 'koh-tao',
    date: '21.11.2024',
    readTime: '2.5',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1029385&k_site=https%3A%2F%2Fwww.klook.com%2Fsearch%2Fresult%2F%3Fquery%3DKoh%2520Tao%26spm%3DPOI_Destination.TopNavigation.SearchInput%26clickId%3D04f066f996',
    getYourGuideUrl:
      'https://www.getyourguide.com/qv-tv-l1563/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: 'קו ליפה',
    description:
      'אי קטן ומדהים ביופיו בדרום תאילנד - מים טורקיז, חופים לבנים, שנורקלינג עוצר נשימה ואווירת גן עדן מבודדת',
    imageUrl: '/images/thailand/koh-lipe/koh-lipe-preview.jpeg',
    slug: 'koh-lipe',
    date: '22.02.2025',
    readTime: '3',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1031296&k_site=https%3A%2F%2Fwww.klook.com%2Fsearch%2Fresult%2F%3Fquery%3Dkoh%2520lipe%26spm%3DHome.TopNavigation.SearchInput%26clickId%3D26a7d0c09e',
    getYourGuideUrl:
      'https://www.getyourguide.com/qv-lyph-l89858/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: 'קו לנטה',
    description:
      'אי רגוע עם חופים בתוליים, טבע פראי, תרבות כפרית ואווירה תאילנדית אותנטית - מושלם למי שמחפש שקט ונוף',
    imageUrl: '/images/thailand/ko-lanta/ko-lanta-preview.jpeg',
    slug: 'ko-lanta',
    date: '15.02.2025',
    readTime: '3',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1031297&k_site=https%3A%2F%2Fwww.klook.com%2Fsearch%2Fresult%2F%3Fquery%3Dkoh%2520lanta%26spm%3DHome.TopNavigation.SearchInput%26clickId%3D6196e31b5e',
    getYourGuideUrl:
      'https://www.getyourguide.com/qv-lnth-l32301/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: 'קאו סוק',
    description:
      'יער גשם קדום, אגם מרהיב, שייט בין מצוקים ולינה בבונגלוס צפים - קאו סוק היא הרפתקת טבע שלא שוכחים',
    imageUrl: '/images/thailand/khao-sok/khao-sok-preview.jpg',
    slug: 'khao-sok',
    date: '09.12.2024',
    readTime: '3.5',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1031298&k_site=https%3A%2F%2Fwww.klook.com%2Fsearch%2Fresult%2F%3Fquery%3DKhao%2520Sok%26spm%3DSearchResult.TopNavigation.SearchInput%26clickId%3Ddcadd97247',
    getYourGuideUrl:
      'https://www.getyourguide.com/hprq-hlvmy-qv-svq-l2674/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: 'איי סימילאן',
    description:
      'איים טרופיים מהיפים בתאילנד - מים צלולים, שוניות עוצרות נשימה וצולילה בלב גן עדן ימי מוגן',
    imageUrl: '/images/thailand/similan-islands/similan-islands-preview.jpg',
    slug: 'similan-islands',
    date: '19.01.2025',
    readTime: '3',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1031299&k_site=https%3A%2F%2Fwww.klook.com%2Fsearch%2Fresult%2F%3Fquery%3DSimilan%2520Islands%26spm%3DHome.TopNavigation.SearchInput%26clickId%3D737f2d2e47',
    getYourGuideUrl:
      'https://www.getyourguide.com/yy-symyln-l88755/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: 'איי סורין',
    description:
      'איים שקטים וקסומים, עם מים צלולים, שוניות מרהיבות וכפר צועני ים - גן עדן אותנטי לחובבי טבע',
    imageUrl: '/images/thailand/ko-surin-nuea/ko-surin-nuea-preview.jpeg',
    slug: 'ko-surin-nuea',
    date: '10.02.2025',
    readTime: '2.5',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1031300&k_site=https%3A%2F%2Fwww.klook.com%2Fsearch%2Fresult%2F%3Fquery%3DKo%2520Surin%2520Nuea%26spm%3DHome.TopNavigation.SearchInput%26clickId%3D6ce0903453',
    getYourGuideUrl:
      'https://www.getyourguide.com/yy-svryn-l89288/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: 'קאו לאק',
    description:
      "חופים זהובים, ג'ונגלים פראיים ואווירה רגועה - קאו לאק היא תאילנד בקצב נינוח",
    imageUrl: '/images/thailand/khao-lak/khao-lak-preview.jpeg',
    slug: 'khao-lak',
    date: '26.01.2025',
    readTime: '2.5',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1031302&k_site=https%3A%2F%2Fwww.klook.com%2Fsearch%2Fresult%2F%3Fquery%3DKhao%2520Lak%26spm%3DSearchResult.TopNavigation.SearchInput%26clickId%3Df29e6b66e5',
    getYourGuideUrl:
      'https://www.getyourguide.com/qv-lq-l32472/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: 'קו קוד',
    description:
      "חול לבן, ג'ונגלים ירוקים וים בצבע טורקיז - קו קוד הוא גן עדן אמיתי למי שמחפש שלווה וניתוק",
    imageUrl: '/images/thailand/koh-kood/koh-kood-preview.jpeg',
    slug: 'koh-kood',
    date: '04.01.2025',
    readTime: '3',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1031304&k_site=https%3A%2F%2Fwww.klook.com%2Fsearch%2Fresult%2F%3Fquery%3DKoh%2520Kood%26spm%3DSearchResult.TopNavigation.SearchInput%26clickId%3D518f0f5be7',
    getYourGuideUrl:
      'https://www.getyourguide.com/qv-qvt-l107307/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: "קו צ'אנג",
    description:
      "חופים לבנים, ג'ונגלים ירוקים, מפלים שוצפים וכפרים על כלונסאות - קו צ'אנג זה כל הטוב שבתאילנד במקום אחד",
    imageUrl: '/images/thailand/koh-chang/koh-chang-preview.jpeg',
    slug: 'koh-chang',
    date: '17.02.2025',
    readTime: '3',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1031306&k_site=https%3A%2F%2Fwww.klook.com%2Fsearch%2Fresult%2F%3Fquery%3DKoh%2520Chang%26spm%3DSearchResult.TopNavigation.SearchInput%26clickId%3Dd7a7a005a4',
    getYourGuideUrl:
      'https://www.getyourguide.com/qv-ts-ng-l2677/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: 'הואה הין',
    description:
      'אם בא לכם חופשה רגועה, עם חופים מטופחים, שווקי לילה צבעוניים ותחושת "תאילנד כמו שפעם" - הואה הין היא הבחירה המושלמת',
    imageUrl: '/images/thailand/hua-hin/hua-hin-preview.jpeg',
    slug: 'hua-hin',
    date: '23.01.2025',
    readTime: '2.5',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1031307&k_site=https%3A%2F%2Fwww.klook.com%2Fcity%2F125-hua-hin-things-to-do%2F%3Fspm%3DSearchResult.SearchSuggest_LIST%26clickId%3D431fdcdbd3',
    getYourGuideUrl:
      'https://www.getyourguide.com/hvh-hyn-l911/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: 'פטאיה',
    description:
      'מעיר החטאים לעיר הנופש - פטאיה מציעה היום הרבה יותר מחיי לילה סוערים: פארקים, שווקים, חופים ואטרקציות לכל המשפחה',
    imageUrl: '/images/thailand/pattaya/pattaya-preview.jpeg',
    slug: 'pattaya',
    date: '08.02.2025',
    readTime: '3',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1031308&k_site=https%3A%2F%2Fwww.klook.com%2Fcity%2F17-pattaya-things-to-do%2F%3Fspm%3DCity.SearchSuggest_LIST%26clickId%3D95fbe512c0',
    getYourGuideUrl:
      'https://www.getyourguide.com/ptyh-l182/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: 'שמורת הטבע דוי אינתהנון',
    description:
      'הטבע בגובה אחר - דוי אינתהנון, ההר הגבוה בתאילנד, מציע פסגות מרהיבות, מפלים שוצפים, כפרים צבעוניים וטיולים בלב יער עננים',
    imageUrl: '/images/thailand/doi-inthanon/doi-inthanon-preview.jpeg',
    slug: 'doi-inthanon',
    date: '13.01.2025',
    readTime: '3.5',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1031309&k_site=https%3A%2F%2Fwww.klook.com%2Fsearch%2Fresult%2F%3Fquery%3DDoi%2520Inthanon%26spm%3DCity.TopNavigation.SearchInput%26clickId%3D8ed37a0762',
    getYourGuideUrl:
      'https://www.getyourguide.com/hprq-hlvmy-dvy-yntnvn-l88850/?partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: 'מקדש גולדן מאונט (Wat Saket)',
    description:
      'מקדש Golden Mount בבנגקוק מציע תצפית עוצרת נשימה, אווירה מדיטטיבית והצצה להיסטוריה מרתקת בלב העיר הסואנת',
    imageUrl: '/images/thailand/wat-saket/wat-saket-preview.jpeg',
    slug: 'wat-saket',
    date: '27.03.2025',
    readTime: '2',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1031310&k_site=https%3A%2F%2Fwww.klook.com%2Fsearch%2Fresult%2F%3Fquery%3DWat%2520Saket%26spm%3DSearchResult.TopNavigation.SearchInput%26clickId%3Dbb69726152',
    getYourGuideUrl: '',
  },
  {
    title: 'קו לארן',
    description:
      'אי טרופי קסום ליד פטאיה, עם חופים לבנים, מים צלולים ואווירה רגועה שמתאימה לחופשת בטן-גב מושלמת',
    imageUrl: '/images/thailand/koh-larn/koh-larn-preview.jpeg',
    slug: 'koh-larn',
    date: '12.02.2025',
    readTime: '2.5',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1031311&k_site=https%3A%2F%2Fwww.klook.com%2Fsearch%2Fresult%2F%3Fquery%3DKoh%2520Larn%26spm%3DSearchResult.TopNavigation.SearchInput%26clickId%3Ddd425b9b59',
    getYourGuideUrl:
      'https://www.getyourguide.com/s/?q=koh+larn&searchSource=3&partner_id=Q3VFO4H&utm_medium=online_publisher',
  },
  {
    title: 'קלונג מה קה',
    description:
      "פינה קסומה ומתחדשת בלב צ'אנג מאי - תעלה ציורית, שוק ערב מקומי ואווירה אותנטית ליד השקיעה",
    imageUrl: '/images/thailand/khlong-mae-kha/khlong-mae-kha-preview.jpeg',
    slug: 'khlong-mae-kha',
    date: '24.02.2025',
    readTime: '2',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1031312&k_site=https%3A%2F%2Fwww.klook.com%2Fsearch%2Fresult%2F%3Fquery%3DKhlong%2520Mae%2520Kha%26spm%3DSearchResult.TopNavigation.SearchInput%26clickId%3Df0772942e4',
    getYourGuideUrl: '',
  },

  {
    title: 'קו קרט',
    description:
      'אי כפרי קטן ליד בנגקוק עם תרבות מון מסורתית, כלי חרס ייחודיים, שבילי אופניים, טבע ושוק סוף שבוע קסום',
    imageUrl: '/images/thailand/koh-kret/koh-kret-preview.jpg',
    slug: 'ko-kret',
    date: '28.02.2025',
    readTime: '2',
    getYourGuideUrl: '',
  },
  {
    title: "בנגקצ'או",
    description:
      'אי ירוק ושליו בלב בנגקוק, עם שבילי אופניים, שוק צף, טבע מרהיב ותחושת כפר אמיתית במרחק דקות מהעיר',
    imageUrl: '/images/thailand/bangkachao/bangkachao-preview.jpeg',
    slug: 'bangkachao',
    date: '27.01.2025',
    readTime: '2.5',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1027043&k_site=https%3A%2F%2Fwww.klook.com%2Fcity%2F4-bangkok-things-to-do%2F%3Fspm%3DSearchResult.SearchSuggest_LIST%26clickId%3D76562f76e0',
    getYourGuideUrl:
      'https://www.getyourguide.com/bngqvq-l169/?partner_id=Q3VFO4H&utm_medium=online_publisher',
    titleNameOverride: 'בנגקוק',
  },
  {
    title: 'פארק לומפיני',
    description:
      'ריאה ירוקה בלב בנגקוק עם אגם, מסלולי ריצה, פעילויות ספורט ולטאות כוח - מקום מושלם להפסקה מההמולה',
    imageUrl: '/images/thailand/lumphini/lumphini-preview.jpeg',
    slug: 'lumphini-park',
    date: '25.12.2024',
    readTime: '2',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1027043&k_site=https%3A%2F%2Fwww.klook.com%2Fcity%2F4-bangkok-things-to-do%2F%3Fspm%3DSearchResult.SearchSuggest_LIST%26clickId%3D76562f76e0',
    getYourGuideUrl:
      'https://www.getyourguide.com/bngqvq-l169/?partner_id=Q3VFO4H&utm_medium=online_publisher',
    titleNameOverride: 'בנגקוק',
  },
  {
    title: "פארק בנצ'קיטי",
    description:
      'הפארק העירוני הגדול בבנגקוק - עם אגם, שבילים ירוקים, גשרים ונוף פתוח שמציעים שקט ושלווה בלב העיר',
    imageUrl: '/images/thailand/benchakitti-park/benchakitti-park-preview.jpeg',
    slug: 'benchakitti-park',
    date: '12.01.2025',
    readTime: '2',
    klookUrl:
      'https://affiliate.klook.com/redirect?aid=86805&aff_adid=1027043&k_site=https%3A%2F%2Fwww.klook.com%2Fcity%2F4-bangkok-things-to-do%2F%3Fspm%3DSearchResult.SearchSuggest_LIST%26clickId%3D76562f76e0',
    getYourGuideUrl:
      'https://www.getyourguide.com/bngqvq-l169/?partner_id=Q3VFO4H&utm_medium=online_publisher',
    titleNameOverride: 'בנגקוק',
  },
  {
    title: 'מערת האמרלד',
    description:
      'מערת האמרלד באי קו מוק - שחייה דרך מנהרה חשוכה אל לגונה סודית בצבעי טורקיז מרהיבים, חלק בלתי נשכח מטיול "4 האיים"',
    imageUrl: '/images/thailand/emerald-cave/emerald-cave-preview.jpeg',
    slug: 'emerald-cave',
    date: '02.02.2025',
    readTime: '2',
    getYourGuideUrl: '',
  },
].map((article) => ({
  ...article,
  articleLink: `/international/thailand/destination/${article.slug}`,
  relatedArticlesSlugs:
    relatedArticlesSlugsMap[
      article.slug as keyof typeof relatedArticlesSlugsMap
    ],
}));
